import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { Config, IntelligentAskAmountsPredictionResponse, MParticleConfig } from './config-types'

const configSlice = createSlice({
  name: 'config',
  initialState: {} as Config, // this is passed in via store initialization
  reducers: {
    setIntelligentAskAmounts: (
      state,
      action: PayloadAction<IntelligentAskAmountsPredictionResponse>,
    ) => {
      return { ...state, intelligentAskAmounts: action.payload }
    },
    setMParticleConfig: (state, action: PayloadAction<MParticleConfig>) => {
      return { ...state, mParticle: action.payload }
    },
  },
})

export default configSlice
